import styled from "styled-components";
import SVG from "react-inlinesvg";
import { BodyDefault, HeadLine3 } from "../typography/styled";
type ActiveProp = {
  active?:boolean,
  $interactive?:boolean,
}
export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<ActiveProp>`
  width: 100%;
  display: ${({active}) => active ? 'flex' : 'none' };;
  box-sizing: border-box;
  justify-content: space-between;
  right:20px;
  transform:${({active}) => active ? '' : 'translate(420px)' };
  opacity:${({active}) => active ? '1' : '0'};
  transition-property: transform, opacity, display;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  align-items: flex-start;
  padding: 13px;
  z-index: 1;
  border: ${({theme}) => `1px solid ${theme.palette[20]}`};
  border-radius: ${({theme}) => theme.radius.card};
  box-shadow: ${({theme}) => theme.shadows.control};
  background-color:${({theme}) => theme.palette[10]};
  &:hover {
    cursor: ${({$interactive}) => $interactive ? 'pointer' : 'default'};
    background: ${({theme, $interactive}) => $interactive ? theme.isDark ? theme.palette[200] : theme.grey[100] : theme.palette[10]};
  }
  &:active{
    background-color: ${({theme, $interactive}) => $interactive ? theme.isDark ? theme.palette[400] : theme.grey[200] : theme.palette[10]};
    transition: 0.1s background-color ease-in-out;
  }

  > [role='button']:focus-visible {
    border-radius: ${({theme}) => theme.radius.xs};
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const DocIcon = styled(SVG)`
  & path {
    fill:${({theme}) => theme.isDark ?  theme.palette[200] : ''};
    stroke:${({theme}) => theme.isDark ?  '#595959' : ''} ;
  }
`

export const IconBackground = styled.div`
  width:48px;
  height:48px;
  margin-right: 15px;
  box-sizing: border-box;
`
export const Title = styled(HeadLine3)`
  color: ${({theme}) => theme.accent[100]};
  /* text-transform: capitalize; */
`

export const TitleWrapper = styled.div`
  display:flex;
  flex-direction: column;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  min-width: 20px;
  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    border-radius: ${({theme}) => theme.radius.xs};
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const CloseIcon = styled(SVG)`
  width: 20px;
  height: 20px;

  & path {
    stroke:${({theme}) => theme.palette[800]};
  }
`

export const Content = styled(BodyDefault)`
  color: ${({theme}) => theme.palette[650]};
  margin-top: 4px;
`
